import httpInstance from './src/http-instance'
import httpDispatch from './src/http-dispatch'

httpInstance.install = function (Vue) {
  Vue.prototype.$_http = httpInstance
  Vue.prototype.$_httpDispatch = httpDispatch
}

export default httpInstance
export {
  httpDispatch
}
